import { toDate } from "common/utils/dates";
import { Feature, UserSubscriptionAction } from "common/types";

import { useCurrentDialog } from "client/common/hooks/stackables";
import ConfirmationDialog from "client/common/components/content/ConfirmationDialog";
import { useFeatures } from "client/clinics/hooks";

import { useUpdateSubscriptionMutation } from "../../hooks";
import { DetailSubscription } from "../../types";

export type SubscriptionSkipNextOrderDialogProps = {
  subscription: DetailSubscription;
};

const SubscriptionSkipNextOrderDialog = ({
  subscription,
}: SubscriptionSkipNextOrderDialogProps) => {
  const { close } = useCurrentDialog();
  const isEdbEnabled = useFeatures()[Feature.AutoshipEDB];
  const {
    mutate: updateSubscription,
    isPending: isLoading,
    error,
  } = useUpdateSubscriptionMutation(subscription.id, {
    onSuccess: close,
  });

  const getDescription = () => {
    if (isEdbEnabled && subscription.skip_expected_delivery_by) {
      return `If you skip this next order, your next estimated delivery will be ${toDate(
        subscription.skip_expected_delivery_by,
      )}`;
    }
    return `If you skip this next order, the new order date will be scheduled for ${toDate(
      subscription.skip_order_date,
    )}`;
  };

  return (
    <ConfirmationDialog
      title="Confirm skipping next order"
      description={getDescription()}
      denyText="No, keep order"
      confirmText="Yes, skip order"
      onConfirm={() => updateSubscription({ action: UserSubscriptionAction.Skip })}
      onDeny={close}
      isLoading={isLoading}
      error={error}
    />
  );
};

export default SubscriptionSkipNextOrderDialog;
